exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/library/modules/_wks-ext.js
 ** module id = 504
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/library/modules/_wks-ext.js
 ** module id = 504
 ** module chunks = 1
 **/